// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blockTitle__KREoN {
  font-size: 11px;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  min-height: 20px;
  display: flex;
  align-items: center;
  column-gap: 5px;
}

.blockContainer__f2oan {
  padding: 25px;
  height: calc(100% - 20px);
  min-height: 430px;
  display: grid;
  grid-template-columns: 140px 1fr minmax(350px, 450px);
  gap: 25px;
  background-color: var(--tables-primary-row-surface-default);
  box-shadow: var(--info-block-box-shadow);
}
@media (max-width: 1600px) {
  .blockContainer__f2oan {
    grid-template-columns: 140px 1fr 320px;
  }
}
@media (max-width: 1400px) {
  .blockContainer__f2oan {
    grid-template-columns: 140px 1fr 270px;
  }
}
@media (max-width: 1300px) {
  .blockContainer__f2oan {
    grid-template-columns: 140px 1fr 400px;
  }
}
@media (max-width: 999px) {
  .blockContainer__f2oan {
    grid-template-columns: 140px 1fr;
  }
}

.extraInfo__bIAxx {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
}

.copyIcon__EOvcS {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.copyIcon__EOvcS path {
  fill: var(--buttons-surface);
}

.mainInfo__lA7md {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
}

.twoFields__hfizs {
  display: grid;
  grid-template-columns: auto 70px;
  align-items: flex-start;
  column-gap: 5px;
}

.btnBlock__rySMy {
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 25px;
}

@media (max-width: 999px) {
  .galleryBlock__EI9Ds {
    grid-area: 2/1/2/3;
  }
}

.skeletonBlockContainer__FoVJS div {
  row-gap: 25px;
}

.skeletonSquare__hMFYO {
  height: 120px;
}

.skeletonText__rhsLu {
  height: 24px;
}

.skeletonGallery__VO2q_ {
  height: 380px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/EquipmentDetails/components/EquipmentDetailsInformation/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,qDAAA;EACA,SAAA;EACA,2DAAA;EACA,wCAAA;AAzEF;AA2EE;EAVF;IAWI,sCAAA;EAxEF;AACF;AA0EE;EAdF;IAeI,sCAAA;EAvEF;AACF;AAyEE;EAlBF;IAmBI,sCAAA;EAtEF;AACF;AAwEE;EAtBF;IAuBI,gCAAA;EArEF;AACF;;AAwEA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AArEF;;AAwEA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AArEF;AAuEE;EACE,4BAAA;AArEJ;;AAyEA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AAtEF;;AAyEA;EACE,aAAA;EACA,gCAAA;EACA,uBAAA;EACA,eAAA;AAtEF;;AAyEA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AAtEF;;AA0EE;EADF;IAEI,kBAAA;EAtEF;AACF;;AA0EE;EACE,aAAA;AAvEJ;;AA2EA;EACE,aAAA;AAxEF;;AA2EA;EACE,YAAA;AAxEF;;AA2EA;EACE,aAAA;AAxEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.blockTitle {\n  font-size: 11px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  min-height: 20px;\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n}\n\n.blockContainer {\n  padding: 25px;\n  height: calc(100% - 20px);\n  min-height: 430px;\n  display: grid;\n  grid-template-columns: 140px 1fr minmax(350px, 450px);\n  gap: 25px;\n  background-color: var(--tables-primary-row-surface-default);\n  box-shadow: var(--info-block-box-shadow);\n\n  @media (max-width: 1600px) {\n    grid-template-columns: 140px 1fr 320px;\n  }\n\n  @media (max-width: 1400px) {\n    grid-template-columns: 140px 1fr 270px;\n  }\n\n  @media (max-width: 1300px) {\n    grid-template-columns: 140px 1fr 400px;\n  }\n\n  @media (max-width: 999px) {\n    grid-template-columns: 140px 1fr;\n  }\n}\n\n.extraInfo {\n  display: flex;\n  flex-direction: column;\n  row-gap: 15px;\n}\n\n.copyIcon {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n\n  path {\n    fill: var(--buttons-surface);\n  }\n}\n\n.mainInfo {\n  display: flex;\n  flex-direction: column;\n  row-gap: 15px;\n}\n\n.twoFields {\n  display: grid;\n  grid-template-columns: auto 70px;\n  align-items: flex-start;\n  column-gap: 5px;\n}\n\n.btnBlock {\n  margin-top: auto;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 25px;\n}\n\n.galleryBlock {\n  @media (max-width: 999px) {\n    grid-area: 2 / 1 / 2 / 3;\n  }\n}\n\n.skeletonBlockContainer {\n  div {\n    row-gap: 25px;\n  }\n}\n\n.skeletonSquare {\n  height: 120px;\n}\n\n.skeletonText {\n  height: 24px;\n}\n\n.skeletonGallery {\n  height: 380px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blockTitle": `blockTitle__KREoN`,
	"blockContainer": `blockContainer__f2oan`,
	"extraInfo": `extraInfo__bIAxx`,
	"copyIcon": `copyIcon__EOvcS`,
	"mainInfo": `mainInfo__lA7md`,
	"twoFields": `twoFields__hfizs`,
	"btnBlock": `btnBlock__rySMy`,
	"galleryBlock": `galleryBlock__EI9Ds`,
	"skeletonBlockContainer": `skeletonBlockContainer__FoVJS`,
	"skeletonSquare": `skeletonSquare__hMFYO`,
	"skeletonText": `skeletonText__rhsLu`,
	"skeletonGallery": `skeletonGallery__VO2q_`
};
module.exports = ___CSS_LOADER_EXPORT___;
